import {types} from './types';

const setGetListGameFreespinAction = (payload) => {
    return {
        type: types.SET_LIST_GAME_FREESPIN,
        payload,
      }
}

const setGetViewGameFreespinAction = (payload) => {
    return {
      type: types.SET_VIEW_GAME_FREESPIN,
      payload
    }
}

export {
  setGetListGameFreespinAction,
  setGetViewGameFreespinAction
}
